import { render } from "./DeleteQuestionModal.vue?vue&type=template&id=f673f0dc"
import script from "./DeleteQuestionModal.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__